<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :onClose="onClose">
    <div>
      <form @submit.prevent="submit()" autocomplete="off" id="issueForm" v-on:keypress.enter.prevent="enterKey">
        <div class="row mx-1">
          <div class="col-12">
            <div class="form-group">
              <label class="generalLabel" for="title"><span className='text-danger'>*</span>Título</label>
              <input type="text" class="form-control generalInput" id="title" v-model.trim.lazy="v$.title.$model"
                maxlength="40">
              <div v-if="v$.title.$dirty">
                <small class="form-text text-danger" v-if="v$.title.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row mx-1">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="generalLabel" for="contractId"><span className='text-danger'>*</span> Nº contrato</label>
              <input type="text" class="form-control generalInput" id="contractId"
                v-model.trim.lazy="v$.contractId.$model" maxlength="40">
              <div v-if="v$.contractId.$dirty">
                <small class="form-text text-danger" v-if="v$.contractId.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="generalLabel" for="type"><span className='text-danger'>*</span> Tipo</label>
              <VueNextSelect class="form-control generalInput" id="type" :options="incidentsTypes"
                v-model.trim="v$.type.$model" placeholder="" searchable="true" clear-on-close="true" close-on-select>
              </VueNextSelect>
              <div v-if="v$.type.$dirty">
                <small class="form-text text-danger" v-if="v$.type.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="generalLabel" for="priority"><span className='text-danger'>*</span> Prioridad</label>
              <VueNextSelect class="form-control generalInput" id="priority" :options="priorityData"
                v-model.trim="v$.priority.$model" placeholder="" searchable="true" clear-on-close="true" close-on-select>
              </VueNextSelect>
              <div v-if="v$.priority.$dirty">
                <small class="form-text text-danger" v-if="v$.priority.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row mx-1">
          <div class="col-12 col-md-12">
            <div class="form-group">
              <label class="generalLabel" for="description"><span className='text-danger'>*</span> Descripción</label>
              <textarea class="form-control generalInput" id="description" v-model.trim.lazy="v$.description.$model"
                maxlength="500" rows="6"></textarea>
              <div v-if="v$.description.$dirty">
                <small class="form-text text-danger" v-if="v$.description.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4 mx-1">
          <div class="col-12">
            <button class="btn generalSecondaryButton" @click="clean()">Limpiar</button>
            <button class="btn btn-primary float-right generalPrimaryButton" id="submitButton"
              v-bind:class="{ disabled: v$.$invalid }" :disabled="v$.$invalid">
            <img v-if="loading" src="../../../../../assets/loader.svg" height="20" alt="">
            <span v-if="!loading">Crear</span>
            </button>
          </div>
        </div>
      </form>
    </div>
    <button :id="id + 'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
   <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
      :message="errorMessage" :code="errorCode" />
</template>
<script>
import axios from 'axios';
import Modal from '../../../Shared/Modal.vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators'
import VueNextSelect from "vue-next-select";
import {  incidentsTypes, incidentsTypesTraduction } from "../common.js";
import ModalError from '../../../Shared/ModalError.vue'
import { Modal as ModalBootstrap } from "bootstrap";



export default {
  name: 'newIssue',
  setup() {
    return { v$: useVuelidate() }
  },
  components: {
    VueNextSelect,
    Modal,
    ModalError,
  },
   props: [
    'id',
    'modalTitle',
    'class',
  ],
  data() {
    return {
      title: "",
      type: "",
      incidentsTypes: incidentsTypes,
      incidentsTypesTraduction: incidentsTypesTraduction,
      priority: "",
      priorityData: ["MUY BAJA", "BAJA", "MEDIA", "ALTA", "CRITICA"],
      priorityDataTraduction: ["VERY_LOW", "LOW", "MEDIUM", "HIGH", "CRITICA"],
      description: "",
      contractId: "",
      user: this.$cookies.get('username'),
      rol: this.$cookies.get('rol'),
      loading: false,
    };
  },
  validations() {
    return {
      title: {
        required,
      },
      contractId: {
        required,
      },
      type: {
        required,
      },
      priority: {
        required,
      },
      description: {
        required,
      },
    }
  },
  mounted() {
    this.clean()
  },
  methods: {
    clean() {
      this.title = '',
      this.contractId = ''
      this.type = '',
      this.priority = '',
      this.description = ''
    },
    async submit() {
      this.loading = true
      const bodyToSend = {
        title: this.title,
        type: this.incidentsTypesTraduction[this.incidentsTypes.indexOf(this.type)],
        priority: this.priorityDataTraduction[this.priorityData.indexOf(this.priority)],
        description: this.description,
        user: this.user,
        contractId: this.contractId
      }

      await axios.post('/incident', bodyToSend)
        .then((response) => {
          if (response.data) {
            this.loading = false
            this.$emit("sendRefreshIssuesList", '');
            this.onClose()
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorCode = error.response.data.code
          this.errorMessage = error.response.data.message
          var myModal = new ModalBootstrap(document.getElementById('modalError'))
          myModal.show()
        });
    },
    enterKey: function (e) {
      if (e.keyCode === 13) {
        if (!document.getElementById('submitButton').classList.contains('disabled')) {
          this.submit();
        }
      }
    },
     onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", '');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.vue-select {
  z-index: 20;
}
</style>